import * as React from 'react';
export const IcUsb = (props: React.SVGProps<SVGSVGElement>): JSX.Element => (
  <svg
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M18 6h-2a1 1 0 00-1 1v2a1 1 0 001 1c0 .9-.77 1.4-2 2.14-.31.19-.64.39-1 .6V6h.25a1 1 0 00.85-1.53l-1.25-2a1 1 0 00-1.7 0l-1.25 2A1 1 0 0010.75 6H11v8.06l-.75-.39c-1.19-.6-1.94-1-2.17-2a2 2 0 10-2 .08c.32 2.19 2 3.06 3.28 3.69.496.214.958.5 1.37.85a3 3 0 102.27-.1v-.28c0-.83.75-1.32 2-2 1.25-.68 3-1.79 3-3.87a1 1 0 001-1V7a1 1 0 00-1-1z'
      fill='currentColor'
    />
  </svg>
);
